var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { superBoxStyle } from '@vital-ui/react-utils';
export var windowStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow: scroll;\n  border-radius: 4px;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  overflow: scroll;\n  border-radius: 4px;\n  ", ";\n"])), superBoxStyle);
export var defaultPopupStyle = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: #43434b;\n  background-color: #ffffff;\n  border-color: #dedee2;\n  min-width: 100px;\n  padding-top: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 6px 20px 0 rgba(99, 99, 111, 0.2);\n"], ["\n  color: #43434b;\n  background-color: #ffffff;\n  border-color: #dedee2;\n  min-width: 100px;\n  padding-top: 8px;\n  margin-bottom: 8px;\n  box-shadow: 0 6px 20px 0 rgba(99, 99, 111, 0.2);\n"])));
var Root = styled('div')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ",
    ";\n  ", ";\n"])), function (_a) {
    var popupStyle = _a.popupStyle;
    return popupStyle ? popupStyle : defaultPopupStyle;
}, windowStyle);
var PopupContent = /** @class */ (function (_super) {
    __extends(PopupContent, _super);
    function PopupContent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PopupContent.prototype.render = function () {
        return React.createElement(Root, __assign({}, this.props), this.props.children);
    };
    return PopupContent;
}(React.Component));
export { PopupContent };
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=PopupContent.js.map